import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  path?: string;
}

function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="mb-6">
      <ol className="flex flex-wrap items-center gap-2 text-sm text-foreground-600">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-2">
              {item.path && !isLast ? (
                <Link to={item.path} className="transition-colors hover:text-primary-600">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-950 font-medium" : ""}>
                  {item.label}
                </span>
              )}
              {!isLast && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumb;